import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { UIText } from '../uIKit';
import { TEXT_TAGS } from 'src/utils/enums';
import ScreenReaderText from '../accessibilityKit/screenReaderText/ScreenReaderText';

interface SuccessMessageProps {
  title: string;
  subtitle?: string;
  titleSize?: number;
  subtitleSize?: number;
  image?: string;
  imageAlt?: string;
  isHidden?: boolean;
  ariaLabel?: string;
}

 const SuccessMessage: React.FC<SuccessMessageProps> = ({
  title,
  subtitle,
  titleSize = 22,
  subtitleSize = 18,
  image,
  imageAlt = 'Success',
  isHidden = false,
  ariaLabel,
}) => {
  // const annouceText = title + ` ` + subtitle
  return (
    <div className={styles.successWrapper}>
      <ScreenReaderText text={ariaLabel ? ariaLabel : [title, subtitle? subtitle : '']} />
      {image && <img src={image} alt={imageAlt} className={styles.successImage} />}
      <UIText
        key={title}
        announce={true}
        politeness="assertive"
        isAriaHidden={isHidden}
        tabIndex={0}
        text={title}
        tag={TEXT_TAGS.H2}
        size={titleSize}
        weight={500}
        style={styles.cardTitle}
      />
      {subtitle && (
        <UIText
          key={subtitle}
          announce={true}
          politeness="assertive"
          isAriaHidden={isHidden}
          tabIndex={0}
          text={subtitle}
          size={subtitleSize}
          weight={400}
          style={styles.cardSubTitleSuccess}
        />
      )}
    </div>
  );
};

export default SuccessMessage;
